import { render, staticRenderFns } from "./OrganModel.vue?vue&type=template&id=0f6b76b0&scoped=true&"
import script from "./OrganModel.vue?vue&type=script&lang=js&"
export * from "./OrganModel.vue?vue&type=script&lang=js&"
import style0 from "./OrganModel.vue?vue&type=style&index=0&id=0f6b76b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6b76b0",
  null
  
)

export default component.exports